import { ISelectItem } from '@lla-platform/core/core-ui'

export enum AnnouncementDeliveryMode {
  Silent = 'Silent',
  Loud = 'Loud'
}

export const AnnouncementDeliveryModeToLabel: Record<string, string> = {
  Silent: 'Silent',
  Loud: 'Loud'
}

export const AnnouncementDeliveryModeItems: ISelectItem[] = Object.values(AnnouncementDeliveryMode).map(
  (value) => ({
    label: AnnouncementDeliveryModeToLabel[value],
    value
  })
)
